import EditProfile from "../../components/editProfile/AccountInformation"

function EditProfilePage() {
    return (
        <>
        <EditProfile/>
        </>
    )
}
export default EditProfilePage